<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="130px">


            <el-form-item label="服务端名称" prop="name" :error="formErrorMsg.name" class="fb-form-item">
                <el-input v-model="formData.name" placeholder="服务端名称"></el-input>
            </el-form-item>

            <el-form-item label="服务端标识" prop="flag" :error="formErrorMsg.flag" class="fb-form-item">
                <el-input v-model="formData.flag" placeholder="服务端标识"></el-input>
            </el-form-item>


            <el-form-item label="配置参数" prop="mfg" :error="formErrorMsg.mfg" class="fb-form-item" style="max-width: 800px">

                <el-table
                        :data="options"
                        border
                        style="width: 100%">
                    <el-table-column
                            prop="key"
                            label="参数名称"
                    >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.key" placeholder="参数名称"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="value"
                            label="参数值"
                    >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.value" placeholder="参数值"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="desc"
                            label="参数描述">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.desc" placeholder="参数描述"></el-input>
                        </template>
                    </el-table-column>
                </el-table>


                <div>
                    <el-button size="mini"  @click="handleAddParam">新增参数</el-button>
                </div>

            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    export default {
        name: "SpdeviceEdit",
        components: {},
        data() {
            return {
                api:{
                   update:this.$api.spDevServer.update,
                   detail:this.$api.spDevServer.detail,
                },
                options:[],

                formErrorMsg:{
                    name: '',
                    flag: '',
                    options:''
                },
                formData: {
                    code:'',
                    name: '',
                    flag: '',
                    options:''

                },
                rules: {
                    name: [
                        {required: true, message: '服务端名称不能为空', trigger: 'blur'},
                    ],
                    flag: [
                        {required: true, message: '服务端标识不能为空', trigger: 'blur'},
                    ]
                }
            }
        },
        watch:{
            options:{
                deep:true,
                handler(){
                    this.formData.options = JSON.stringify(this.options);
                }
            }
        },
        methods: {
            handleAddParam(){
                this.options.push({key:'',value:'',desc:''});
            },
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.update,vm.$qs.stringify(this.formData)).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){
                                if(resp.data.data.errorFields){
                                    resp.data.data.errorFields.forEach(function (a) {

                                        vm.formErrorMsg[a.name] = '';
                                        vm.$nextTick(() => {
                                            vm.formErrorMsg[a.name] = a.message;
                                        });
                                    });
                                }

                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                });
                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },

        created() {

            let vm = this;
            this.$http.post(this.api.detail,this.$qs.stringify(this.$route.query)).then(function (resp) {
                for(let key in resp.data.data){
                    for(let fKey in vm.formData){
                        vm.formData[fKey] = resp.data.data[key][fKey];
                    }
                }
                vm.options =JSON.parse(vm.formData.options);
            });

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }

</style>


<style>

    .editor-item{
         position: relative;
    }

    .editor-item >.el-form-item__content{
        line-height: initial !important;
    }
</style>